/** Encodes CSV cells and neutralizes spreadsheet formulas in untrusted data. */
export function csvCell(value: unknown) {
  // CSV has no escaping for record-breaking controls. Remove them before
  // formula detection so a BOM or newline cannot hide a formula prefix.
  const text = String(value ?? "").replace(/[\u0000-\u001f\u007f\ufeff]/g, " ");
  const safe = /^\s*[=+\-@]/.test(text) ? `'${text}` : text;
  return `"${safe.replaceAll('"', '""')}"`;
}
